<section class="secondary-drawer-container">
    <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
    <h5 class="drawer-title">Image Editor</h5>
</section>
<div class="custom-scroller img-editor-scroller">
    <div>
        <pixie-editor></pixie-editor>
    </div>
    <div class="form-group mb-3">
        <div class="font-12 font-medium text-left font-poppins mt-5 mb-2">
            Comments
        </div>
        <div>
              <app-quill-editor class="mb-3" [Note]="imageDetails.comment" (QuillEditorChange)='updateComment($event)'></app-quill-editor>
        </div>
    </div>
</div>